import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { BatchService } from './api/batch.service';
import { ElementsService } from './api/elements.service';
import { MouldsService } from './api/moulds.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class MouldDesignApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<MouldDesignApiModule> {
        return {
            ngModule: MouldDesignApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: MouldDesignApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('MouldDesignApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
